import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import cx from 'classnames';

import { SecondaryNavButtonProps } from '../SecondaryNavigation.types';
import { Icon } from '@goed/ui-components';
import { LanguageLink } from '../../../../language-link';

import React, { forwardRef } from 'react';
import { RoutesEnum } from '@goed-platform/shared/types';

export const SecondaryNavButton = forwardRef<HTMLButtonElement, SecondaryNavButtonProps>(
    (
        {
            callToAction,
            label,
            variant = 'primary',
            modExpendable = false,
            modLink = false,
            modButton = false,
            modLogout = false,
            onClick,
        }: SecondaryNavButtonProps,
        ref
    ): JSX.Element => {
        const classNames = cx(
            'secondary-nav__btn',
            `secondary-nav__btn--${variant}`,
            modExpendable && 'secondary-nav__btn--expendable',
            modLink && 'secondary-nav__btn--link',
            modLogout && 'secondary-nav__btn--logout'
        );

        if (
            callToAction &&
            callToAction.__typename === 'InternalLinkRecord' &&
            callToAction.link?.__typename === 'PageRecord'
        ) {
            return (
                <NavigationMenu.Link asChild>
                    <LanguageLink href={`/${callToAction.link.slug}`}>
                        <a className={classNames}>{label}</a>
                    </LanguageLink>
                </NavigationMenu.Link>
            );
        }

        if (callToAction && callToAction.__typename === 'ExternalLinkRecord') {
            return (
                <NavigationMenu.Link asChild>
                    <LanguageLink href={callToAction.url ?? '/'}>
                        <a className={classNames} target={callToAction.openInNewWindow ? '_blank' : undefined}>
                            {label}
                            {callToAction.openInNewWindow && <Icon name="arrow-up-right" />}
                        </a>
                    </LanguageLink>
                </NavigationMenu.Link>
            );
        }

        if (modLogout) {
            return (
                <NavigationMenu.Link asChild>
                    <LanguageLink href={RoutesEnum.logout}>
                        <a className={classNames}>
                            {label}
                            <Icon name="log-out" />
                        </a>
                    </LanguageLink>
                </NavigationMenu.Link>
            );
        }

        if (modButton && onClick) {
            return (
                <button className={classNames} onClick={onClick} ref={ref}>
                    {label} {modExpendable && <Icon name="chevron-down" size={20} />}
                </button>
            );
        }

        return (
            <NavigationMenu.Trigger
                className={classNames}
                onPointerMove={(event) => event.preventDefault()}
                onPointerLeave={(event) => event.preventDefault()}
                ref={ref}
            >
                {label} {modExpendable && <Icon name="chevron-down" size={20} />}
            </NavigationMenu.Trigger>
        );
    }
);

SecondaryNavButton.displayName = 'SecondaryNavButton';
